<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="true" :crubList="[{name:'金融合作伙伴管理'},{name:'附件资料管理',goback:true},{name:'新增附件资料'}]" :title="'新增附件资料'"/> -->
            <!-- 表单 -->
            <div class="box" v-loading="loading"
                element-loading-text="请求中......">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>入会须知：</div>
                        <div class="content">
                           <el-input type="textarea" :autosize="{ minRows: 4}" placeholder="限200字" v-model="sendInfo.notice" show-word-limit maxlength="200"></el-input>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.notice']">错误提示：{{errors['sendInfo.notice']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>入会服务：</div>
                        <div class="content">
                           <el-input type="textarea" :autosize="{ minRows: 4}" placeholder="限200字" v-model="sendInfo.serve" show-word-limit maxlength="200"></el-input>
                        </div>
                        
                    </div>
                    <div class="error" v-if="errors['sendInfo.serve']">错误提示：{{errors['sendInfo.serve']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>政策服务：</div>
                        <div class="content">
                             <el-input type="textarea" :autosize="{ minRows: 4}" placeholder="限200字" v-model="sendInfo.policy" show-word-limit maxlength="200"></el-input>
                        </div>
                        
                    </div>
                    <div class="error" v-if="errors['sendInfo.policy']">错误提示：{{errors['sendInfo.policy']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>其他：</div>
                        <div class="content">
                             <el-input type="textarea" :autosize="{ minRows: 4}" placeholder="限200字" v-model="sendInfo.rests" show-word-limit maxlength="200"></el-input>
                        </div>
                        
                    </div>
                    <div class="error" v-if="errors['sendInfo.rests']">错误提示：{{errors['sendInfo.rests']}}</div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                             <div class="singleBtn">
                      <el-button type="primary" size="small" @click="submit">发布</el-button>
                    </div>
                        </div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
import {API} from "@/axios/config";
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import wangEnduit from '../../components/Editor/index';
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoadFiles,
        wangEnduit
    },
    data(){
        return{
          loading:false,
            statusList: [],//服务类型
			id:'',
            sendInfo:{
                id:void 0,// ，编辑时必传
                notice: void 0, // 入会须知
                policy: void 0,  // 政策服务
                rests: void 0,// 其他
                serve: void 0, // 入会服务
            },
            province:[],
			dict:{
				currentPage:1,
				direction:null,
				pageSize:10,
				parentId :1069409909080064,
				property:null,
			}
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		this.getDetail();
		
	},
    vuerify: {
		'sendInfo.notice':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'请填写入会须知'
		},
		'sendInfo.policy':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'请填写政策服务'
		  },
      'sendInfo.serve':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'请填写入会服务'
		  },
      'sendInfo.rests':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'请填写其他'
		  }
    },
    methods:{
     
		getDetail(){
      this.loading = true
			this.$axiosc.get('/backstage/vipServe/findVipServeDetails').then((r)=>{
			    if(r.code==200){
					    this.sendInfo=r.data
              this.loading = false
			    }else{
			        this.$alert(r.msg)
              this.loading = false
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
              this.$axioscBody.post('/backstage/vipServe/saveVipServe',this.sendInfo).then((r)=>{
                if(r.code==200){
                  this.$message({
                    type: 'success',
                    message: r.msg
                  });
                  this.getDetail()
                }else{
                  this.$alert(r.msg);
                }
              })
            }
        },
        /** 富文本编辑器图片上传 */
    handleUploadEditor(file, callback) {
      const that = this
      const formData = new window.FormData()
      formData.append('file', file)
      // 上传 todu
      that.$axiosz.post(API.UploadsService + "backstage/annex/file", formData).then(res => {
        const {data,code,msg} = res
        if(code === 200){
        const { frontPath, filePath,fileName } = data
        const param = { ...data }
        param.name = fileName
        param.url = frontPath + filePath
        callback(param)
        }
      }).catch(e => {
        // that.$message.info('上传失败')
        that.$alert('上传失败')
        console.log(e)
      })
    },
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:100%;
    overflow: hidden;
    .box{
        
        padding-top:20px;
        height:calc(94% - 20px);
     overflow-x: hidden;
     overflow-y: auto;
        .forms{
            max-width: 750px;
            margin: auto;
            .child{
              align-items: flex-start;
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: left;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>